import Vue from 'vue';
import { historyPush } from '@studiometa/js-toolkit/utils';
import eventBus from '../eventbus.js';

export default {
  /**
   * Set endpoints value
   * @param {object} state store
   * @param {object} payload endpoints from twig template
   */
  SET_ENDPOINTS(state, payload) {
    state.endpoints = payload;
  },

  /**
   * Set geoJSON from the api
   * @param {object} state store
   * @param {object} payload geoJSON from api
   */
  SET_GEOJSON(state, payload) {
    state.geojson = payload;
    state.geojsonLoaded = true;
  },

  /**
   * Set Main filters with data from the api
   * @param {object} state store
   * @param {object} payload filters from api
   */
  SET_MAIN_FILTERS(state, payload) {
    // Assign filter value based on GET params.
    const params = new URLSearchParams(window.location.search);
    payload.forEach((item) => {
      if (params.get(item.name)) {
        item.value = params.get(item.name);
      }
    });

    // Save mainFilters to state.
    state.mainFilters = payload;
    state.activeFilters = JSON.parse(JSON.stringify(payload));
    state.mainFiltersLoaded = true;
  },

  /**
   * Set Secondary filters with data  from the api
   * @param {object} state store
   * @param {object} payload filters from api
   */
  SET_SECONDARY_FILTERS(state, payload) {
    const params = new URLSearchParams(window.location.search);
    let hasFilters = false;
    payload.forEach((item) => {
      if (params.get(item.name)) {
        item.value = params.get(item.name).split(',');
        hasFilters = true;
      }
    });

    if (hasFilters) {
      state.secondaryFilters = payload;
      state.secondaryFiltersLoaded = true;
      return;
    }

    state.secondaryFilters = payload;
    state.secondaryFiltersLoaded = true;
  },

  /**
   * Update Form values
   * @param {object} state state
   * @param {object} values to set in formValues
   * @param {string} values.name of the value to set
   * @param {string} values.value value input set
   */
  SET_FORM_VALUES(state, { name, value }) {
    state.formValues[name] = value;

    // Enable/disable all others filters when a cellar is choosen
    if (name === 'cellar') {
      state.activeFilters.forEach((element) => {
        if (element.name !== 'cellar') {
          element.disabled = value !== '-1';
        }
      });
    }

    if (name === 'tourist-route') {
      state.activeFilters.forEach((element) => {
        if (element.name === 'town' || element.name === 'radius') {
          element.disabled = value !== '-1';
        }
      });

      const params = new URLSearchParams(window.location.search);

      state.secondaryFilters.forEach((element) => {
        if (element.name !== 'interest-points-type[]') {
          return;
        }

        if (value === '-1') {
          state.formValues[element.name] = [];
          element.value = [];
          return;
        }

        if (params.has(element.name) && params.get(element.name).length > 0) {
          return;
        }

        state.formValues[element.name] = Object.keys(element.options);
        element.value = Object.keys(element.options);
      });
    }

    // Edit the cellar filter options to only display those who match the selected route
    if (name === 'tourist-route' && state.activeFilters.length > 0) {
      state.activeFilters[0].options = state.mainFilters.length
        ? JSON.parse(JSON.stringify(state.mainFilters[0].options))
        : {};

      let { options } = state.activeFilters[0];

      if (value !== '-1') {
        options = Object.values(state.activeFilters[0].options).filter((option) => {
          return option.tourist_route.includes(Number(state.formValues['tourist-route']));
        });
      }

      Vue.set(state.activeFilters[0], 'options', options);
      eventBus.$emit('reset-cellar');
    }

    // Edit the cellar filter options to only display those who match the selected town
    if (name === 'town' && state.activeFilters.length > 0) {
      state.activeFilters[0].options = JSON.parse(JSON.stringify(state.mainFilters[0].options));
      let { options } = state.activeFilters[0];

      if (value !== '-1') {
        options = Object.values(state.activeFilters[0].options).filter((option) => {
          return option.town && option.town.includes(state.formValues.town);
        });
      }

      Vue.set(state.activeFilters[0], 'options', options);
      eventBus.$emit('reset-cellar');
    }

    const URLparams = new URLSearchParams(state.formValues);

    const currentURLParams = new URLSearchParams(window.location.search);

    currentURLParams.forEach((param, key) => {
      if (!param.length || URLparams.has(key)) {
        return;
      }

      URLparams.append(key, param);
    });

    const paramToRemove = [];

    URLparams.forEach((param, key) => {
      if (param.length) {
        return;
      }

      paramToRemove.push(key);
    });

    paramToRemove.forEach((k) => URLparams.delete(k));

    historyPush({
      search: URLparams,
    });
  },

  /**
   * Set results
   * @param {object} state state
   * @param {Array} results
   */
  SET_RESULTS(state, results) {
    state.results = results;
    if (state.results.length === 0) {
      state.noResults = true;

      setTimeout(() => {
        state.noResults = false;
      }, 2000);
    }
  },

  /**
   * Reset Form Values
   * @param {object} state
   */
  RESET_FORM_VALUES(state) {
    state.formValues = {};
    state.results = [];
    state.activeFilters.forEach((element) => {
      element.value = '-1';
      element.disabled = false;
    });

    state.activeFilters[0].options = JSON.parse(JSON.stringify(state.mainFilters[0].options));
    Vue.set(state.activeFilters[0], 'options', state.activeFilters[0].options);

    window.history.replaceState(null, '', window.location.pathname);

    state.secondaryFilters.forEach((element) => {
      element.value = [];
    });
  },
};
